import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";


function Dashboard() {
  const { loading: profileLoading } = useSelector((state) => state.profile);
  const { loading: authLoading } = useSelector((state) => state.auth);


  if (profileLoading || authLoading) {
    return (
      <div className="grid min-h-screen place-items-center">
        <div className="spinner"></div>
      </div>
    );
  }


  return (
    <div className="flex  min-h-screen">



        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>

    </div>
  );
}

export default Dashboard;
